import script from "./Recaptcha.vue?vue&type=script&lang=ts"
export * from "./Recaptcha.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__